import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/Roxe_RISN.png'
import _imports_1 from '../../assets/imgs/Roxe_QR.png'
import _imports_2 from '../../assets/imgs/Roxe_SquadDeal.png'
import _imports_3 from '../../assets/imgs/Roxe_eGC.png'


const _withScopeId = n => (_pushScopeId("data-v-0b53afee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_4 = {
  class: "header",
  id: "font-size"
}
const _hoisted_5 = {
  class: "h6 mt20",
  id: "font-size"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:support@roxe.io",
  style: {"color":"#30295c"}
}, "support@roxe.io", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "grid mb100 max mt30" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Tail = _resolveComponent("Tail")!
  const _directive_trnew = _resolveDirective("trnew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _hoisted_3,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createTextVNode("Frequently Asked Questions")
    ])), [
      [_directive_trnew]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      _createTextVNode(" We are happy to answer any questions that you have. If you are still not satisfied, please"),
      _hoisted_6,
      _createTextVNode(" contact "),
      _hoisted_7
    ])), [
      [_directive_trnew]
    ]),
    _hoisted_8,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotolink('RISN-FAQs'))),
              style: {"cursor":"pointer"},
              src: _imports_0,
              width: "500"
            }),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotolink('RISN-FAQs'))),
              style: {"cursor":"pointer"},
              id: "faq-size"
            }, "RISN")
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotolink('QR-Payment-FAQs'))),
              style: {"cursor":"pointer"},
              src: _imports_1,
              width: "500"
            }),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotolink('QR-Payment-FAQs'))),
              style: {"cursor":"pointer"},
              id: "faq-size"
            }, " QR Payments ")
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotolink('Squad-deal-FAQs'))),
              style: {"cursor":"pointer"},
              src: _imports_2,
              width: "500"
            }),
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotolink('Squad-deal-FAQs'))),
              style: {"cursor":"pointer"},
              id: "faq-size"
            }, " Squad Deals ")
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotolink('Egiftcard-FAQs-Questions'))),
              style: {"cursor":"pointer"},
              src: _imports_3,
              width: "500"
            }),
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gotolink('Egiftcard-FAQs-Questions'))),
              style: {"cursor":"pointer"},
              id: "faq-size"
            }, " eGiftCards ")
          ])
        ])
      ])
    ])), [
      [_directive_trnew]
    ]),
    _createVNode(_component_Tail)
  ]))
}